import * as React from "react"
import * as styles from "./styles.scss"
import Grayframe from "components/Grayframe"
import * as cx from "classnames"
import BaseRow from "./BaseRow"
import ExpandedContent from "./ExpandedContent"
import {
  EditModelAdvertAreaContentEditorTypes,
  GetEditOrderPageCaseFolder_caseFolder_editTabs,
  GetOrderById_orders_mediaOrder_edit_editModelAdvert_basePage_areas_content_editor_help,
  AreaFragment_content_validateItems,
  EditModelAdvertAreaContentValidateKinds,
} from "schema"
import { OrderEditorContext } from "./../../../../../OrderEditoryAdvert"
import { useContextSelector } from "use-context-selector"
import Help from "./Help"

const Area: React.FC<Props> = (props) => {
  const {
    label,
    onClick,
    onMouseEnter,
    onMouseLeave,
    isExpanded,
    type,
    children,
  } = props

  const { isLocked } = useContextSelector(OrderEditorContext, (s) => {
    return {
      isLocked: s.isLocked,
    }
  })

  return (
    <Grayframe
      className={cx(styles.item, {
        [styles.adstateviews__item]: props.isFEUser,
        [styles.expanded]: isExpanded,
        [styles.disabled]: isLocked,
      })}
    >
      <BaseRow
        label={label}
        onClick={onClick}
        isExpanded={isExpanded}
        disabled={isLocked}
        validationItems={props.validateItems}
        isFEUser={props.isFEUser}
      />
      {children && (
        <ExpandedContent
          isExpanded={isExpanded}
          type={type}
          editTabs={props.editTabs}
          isFEUser={props.isFEUser}
          isOverflowHidden={props.isOverflowHidden}
        >
          <div className={styles.expandedHeaderContent}>
              <Help help={props.help} isFEuser={props.isFEUser} />
              <Help help={props.help} isHoverActive={true} isGalleryArea={props.isGalleryArea} isFEuser={props.isFEUser} handleAreaOverFlowChange={props.handleAreaOverFlowChange} />
          </div>

          <div className={styles.validationBox}>
            {props.isFEUser && props.validateItems.some(q=>q.kind == EditModelAdvertAreaContentValidateKinds.ERROR) && 
              <div className={styles.validationText}>
                <div className={styles.validationTextInner}>
                {props.validateItems.filter(q=>q.kind == EditModelAdvertAreaContentValidateKinds.ERROR).map(m=><div>{m.validationText}</div>)}
                </div>
              </div>
            }            
          </div>


          {children}
        </ExpandedContent>
      )}
    </Grayframe>
  )
}

interface Props {
  label: string
  isExpanded: boolean
  // component: React.ComponentClass<any> | React.StatelessComponent<any> | null
  onClick: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  type: EditModelAdvertAreaContentEditorTypes
  editTabs: GetEditOrderPageCaseFolder_caseFolder_editTabs[]
  validateItems: AreaFragment_content_validateItems[]
  isFEUser: boolean
  isOverflowHidden: boolean
  help:  GetOrderById_orders_mediaOrder_edit_editModelAdvert_basePage_areas_content_editor_help | null
  handleAreaOverFlowChange: (arg: boolean) => void
  isGalleryArea: boolean
}
export default Area
